import { getCurrencySymbol } from './getCurrencySymbol';

export const formatMonthlyPrice = (
  value: number,
  currency: string,
  periodLabel: string
): string =>
  value || value === 0
    ? `${getCurrencySymbol(currency)}${value?.toFixed(2)} / ${periodLabel}`
    : 'Not Found';
